module.exports = __webpack_public_path__ + "static/media/img-1-en.908da8b6.webp";